import { render, staticRenderFns } from "./DirectoryItem.vue?vue&type=template&id=06e5f514&scoped=true&style=height%3A%2050px&"
import script from "./DirectoryItem.vue?vue&type=script&lang=ts&"
export * from "./DirectoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./DirectoryItem.vue?vue&type=style&index=0&id=06e5f514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5f514",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VListItem,VListItemContent,VListItemTitle,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e5f514')) {
      api.createRecord('06e5f514', component.options)
    } else {
      api.reload('06e5f514', component.options)
    }
    module.hot.accept("./DirectoryItem.vue?vue&type=template&id=06e5f514&scoped=true&style=height%3A%2050px&", function () {
      api.rerender('06e5f514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/directory/components/DirectoryItem.vue"
export default component.exports